import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class Warehouse  {
    _originalTypeClassName = "zERP.BO.Warehouse";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
Warehouse.translate = translateService;
}
this.Warehouses = [];
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Code = null;
this.Name = null;
this.Enabled = false;
this.Phone = null;
this.Phone2 = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Enabled:any;
Phone:any;
Phone2:any;
Address:any;
Warehouses:any;
ParentWarehouse:any;
Responsible:any;
Entity:any;
static setAddress = ($this, value) => {
var oldValue = $this.Address;
$this.Address = value;
if (value != null) {
}
}
static setWarehouses = ($this, items) => {
                if (items == null) items = [];
                if ($this.Warehouses == null) $this.Warehouses = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Warehouses.length > 0) {
                    Domain.Warehouse.removeWarehouses($this, $this.Warehouses[0]);
                }

                Domain.Warehouse.addManyWarehouses($this, copyItems);
            }
static addManyWarehouses = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.Warehouse.addWarehouses($this, items[i]);
                }
            }
static addWarehouses = ($this, item) => {
                if ($this.Warehouses == null) $this.Warehouses = [];
                if (item == null || $this.Warehouses.indexOf(item) > -1) return;
                $this.Warehouses.push(item);
if (item.ParentWarehouse != $this) {
Domain.Warehouse.setParentWarehouse(item, $this);
}
}
static addRangeWarehouses = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.Warehouse.addWarehouses($this, item));
            }
static removeWarehouses = ($this, item) => {
                if ($this == null || $this.Warehouses == null || $this.Warehouses.indexOf(item) === -1) return;
                var _index = $this.Warehouses.indexOf(item);
                $this.Warehouses.splice(_index, 1);
item.ParentWarehouse = null;
}
static clearWarehouses = ($this) => { $this.Warehouses = null; }
static setParentWarehouse = ($this, value) => {
var oldValue = $this.ParentWarehouse;
$this.ParentWarehouse = value;
if (value != null) {
if (oldValue != null) {
Domain.Warehouse.removeWarehouses(oldValue, $this);
}
Domain.Warehouse.addWarehouses(value, $this);
}
}
static setResponsible = ($this, value) => {
var oldValue = $this.Responsible;
$this.Responsible = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}